export interface EndpointDirectoriesSettings {
  [endpoint: string]: any | string | (any | string)[];
}
